function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8093"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7916"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36",
  d: "M70 134.156c38.66 0 70-30.032 70-67.078S108.66 0 70 0 0 30.032 0 67.078s31.34 67.078 70 67.078",
  fill: "#e8f6f4"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7917"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37",
  d: "M68.654 66.945h2.142a2.872 2.872 0 012.048.892 2.819 2.819 0 01.744 2.049 2.976 2.976 0 01-2.983 2.403h-2.882a1.779 1.779 0 01-1.768-1.336 1.1 1.1 0 00-1.114-.8h-3.35a1.034 1.034 0 00-.837.355 1.211 1.211 0 00-.277.8 7.154 7.154 0 006.325 6.24v2.762a1.051 1.051 0 001.114 1.079h3.256a1.054 1.054 0 001.118-1.071v-2.856a8.279 8.279 0 006.789-6.953 8.005 8.005 0 00-2.138-6.151 8.339 8.339 0 00-6.145-2.583H68.19a2.879 2.879 0 01-2.048-.892 2.819 2.819 0 01-.746-2.049 2.972 2.972 0 012.977-2.407h3.073a1.776 1.776 0 011.765 1.336 1.114 1.114 0 001.118.8h3.349a1.032 1.032 0 00.837-.358 1.214 1.214 0 00.277-.8 7.154 7.154 0 00-6.325-6.24v-2.762a1.051 1.051 0 00-1.115-1.068h-3.256a1.051 1.051 0 00-1.117 1.068v2.765a8.1 8.1 0 00-6.789 8.644c.277 4.012 4.09 7.133 8.464 7.133z",
  fill: "#a1dbd3"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7918"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38",
  d: "M89.442 24.782H49.255a4.9 4.9 0 00-5.021 4.814v74.964a4.9 4.9 0 005.021 4.814h40.187a4.9 4.9 0 005.024-4.814V29.596a4.9 4.9 0 00-5.024-4.814m-25.952 4.9h11.533a1.603 1.603 0 110 3.207H63.49a1.603 1.603 0 110-3.207zm5.858 74.519a4.166 4.166 0 01-4.277-4.008 4.105 4.105 0 014.277-4.011 4.014 4.014 0 110 8.021m18.606-13.281H50.746V37.707h37.208z",
  fill: "#a1dbd3"
})));
var SvgCellphone = function SvgCellphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 134.156"
  }, props), _ref);
};
export default SvgCellphone;